import { actionTypes } from './actions';
import { initialState } from './initial';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_USER_PARENT_INFO: {
      const userParentInfo = action.payload?.[actionTypes.GET_USER_PARENT_INFO]?.userInfo;

      if (userParentInfo !== undefined)
        return {
          ...state,
          userParentInfo,
        };
      return state;
    }
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };
    case actionTypes.CREATE_USER_SUCCESS:
      return {
        ...state,
        actionProcessing: false,
      };

    case actionTypes.GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        usersList: { ...action.payload, totalCount: action.payload.users.length === 1 ? 1 : action.payload.totalCount },
        actionProcessing: false,
      };

    case actionTypes.GET_USERS_LIST_FAILED:
      return {
        ...state,
        usersList: {
          balanceSum: 0,
          totalCount: 0,
          users: [],
        },
        actionProcessing: false,
      };

    case actionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        actionProcessing: false,
        newPassword: action.payload,
      };

    case actionTypes.GET_USER_INFO_SUCCESS:
      return {
        ...state,
        actionProcessing: false,
        userInfo: action.payload,
      };

    case actionTypes.USER_INFO_DELETE:
      return {
        ...state,
        actionProcessing: false,
        userInfo: {},
      };

    case actionTypes.DATA_REFRESH: {
      return {
        ...state,
        actionProcessing: false,
        isNeedToRefresh: !state.isNeedToRefresh,
      };
    }

    case actionTypes.GET_BANNED_PROVIDERS: {
      return {
        ...state,
        actionProcessing: false,
        bannedProviders: action.payload.blocklist,
        semiAutoWithdrawalEnabled: action.payload.semiAutoWithdrawalEnabled,
        isVisibleFeedbackLink: action.payload.isVisibleFeedbackLink,
      };
    }

    case actionTypes.SET_BANNED_PROVIDERS: {
      return {
        ...state,
        actionProcessing: false,
        userInfo: {
          ...state.userInfo,
          bannedProviders: action.payload,
        },
      };
    }

    case actionTypes.GET_PROFILE_INFO: {
      return {
        ...state,
        profile: action.payload,
      };
    }

    case actionTypes.GET_REF_CODE: {
      return {
        ...state,
        refCode: action.payload,
      };
    }

    default:
      return { ...state };
  }
}
